import { render, staticRenderFns } from "./inventoryItem.vue?vue&type=template&id=5bc1f295"
import script from "./inventoryItem.vue?vue&type=script&lang=js"
export * from "./inventoryItem.vue?vue&type=script&lang=js"
import style0 from "./inventoryItem.vue?vue&type=style&index=0&id=5bc1f295&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports